import { BoardingClassSessionAttendance } from '@/plugins/api'
const ABSENT_STATE = { EXCUSED: 1, UNEXCUSED: 2, NONE: 0 }

const getSubStatus = (val = 0) => {
  switch (val) {
    case ABSENT_STATE.EXCUSED:
      return 'excused'
    case ABSENT_STATE.UNEXCUSED:
      return 'unexcused'
    default:
      return 'none'
  }
}

export default {
  namespaced: true,
  state: {
    items: [],
    itemsChangeKey: 0,
    //
    absents: {}
  },
  actions: {
    reset({ commit }) {
      commit('changeState', { items: [], itemsChangeKey: 0, absents: {} })
    },
    async fetchItems({ commit, state }, params) {
      const items = await BoardingClassSessionAttendance.fetch(params)
      const absents = {}
      items.forEach(i => {
        if (i.status === 'absent') absents[i.id] = true
      })
      commit('changeState', {
        items,
        itemsChangeKey: state.itemsChangeKey + 1,
        absents
      })
      return items
    },
    updateBySession(_, { id, ...params }) {
      return BoardingClassSessionAttendance.updateBySession(id, params)
    }
  },
  mutations: {
    addToAbsents(state, id) {
      state.absents[id] = ABSENT_STATE.NONE
    },
    removeFromAbsents(state, id) {
      delete state.absents[id]
    },
    markAbsentExcused(state, id) {
      state.absents[id] = ABSENT_STATE.EXCUSED
    },
    markAbsentUnexcused(state, id) {
      state.absents[id] = ABSENT_STATE.UNEXCUSED
    }
  },
  getters: {
    items: state => state.items,
    itemsChangeKey: state => state.itemsChangeKey,
    //
    absents: state => Object.keys(state.absents).map(id => ({ id, subStatus: getSubStatus(state.absents[id]) }))
  }
}
